
export { default as takeLast } from "./takeLast.js"